import { useQuery, useSubscription } from "@apollo/client";
import { Card, Empty, Form, Input, message } from "antd";
import moment from "moment";
import { Fragment, useState } from "react";
import { useParams } from "react-router";
import { Loader } from "../../../../Components/Loader";
import { GET_USER_NAME } from "../../../../Graphql/queries";
import { GET_USER_TODAY_TASK_STATUS } from "../../../../Graphql/subscriptions";
import Empty_yourtaskfortheday from "../../../../Assets/Images/Empty/Empty_yourtaskfortheday.svg";
import "./EmployeeTaskStatus.less";
import TaskQrCodeModal from "../../../../Components/Drawers/TaskQrCode/TaskQrCodeModal";
import { usePermissionUser } from "../../../../Utils/Context/permissionContext";

const { Search } = Input;

export const EmployeeTaskStatus = () => {
  const [userTaskId, setUserTaskId] = useState();
  const [showQrDrawer, setShowQrDrawer] = useState(false);
  const { employee_id } = useParams();
  const { userPermissionAccess: permission } = usePermissionUser();

  const { data: userNameData } = useQuery(GET_USER_NAME, {
    variables: { user_id: employee_id },
  });

  const { data: todayTask, loading: todayTaskLoading } = useSubscription(
    GET_USER_TODAY_TASK_STATUS,
    {
      variables: {
        user_id: employee_id,
        task_date: moment().format("YYYY-MM-DD"),
      },
      shouldResubscribe: true,
    }
  );

  const onViewDeails = (user_task_id) => {
    setUserTaskId(user_task_id);
    setShowQrDrawer(true);
  };
  return (
    <Fragment>
      <section className="manageTaskEmployee">
        <div className="secSubTitle pageSubTilte">
          <div className="stLeft">
            <h5 className="">
              {userNameData?.getUsersById?.first_name
                ? userNameData?.getUsersById?.first_name + "'s"
                : ""}{" "}
              tasks status
            </h5>
          </div>
          <div className="stRight">
            <h5>Today</h5>
          </div>
        </div>
      </section>

      <div className="taskEditRow mb-4" bordered={false}>
        {/* <div className="secSubTitle">
          <div className="stLeft">
            <h5>Custom tasks</h5>
          </div>
        </div> */}
        <div className="taskStatusListSection">
          <ul className="list-inline taskStatusForDayList">
            {todayTaskLoading ? (
              <Loader />
            ) : todayTask?.user_tasks_map.length === 0 ? (
              <Empty
                image={Empty_yourtaskfortheday}
                description={
                  <span>
                    No tasks updated by employee yet. Once the employee updates
                    the status, you will see it here!
                  </span>
                }
              />
            ) : (
              todayTask?.user_tasks_map.map((singleTasks, index) => (
                <li
                  key={index}
                  className={`d-flex flex-column myTaskStatusForDay ${singleTasks.task_status}`}
                >
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="">
                      <div className={`tags ${singleTasks?.task.task_type}`}>
                        {singleTasks.task.taskTypeByTaskType.type_name}
                      </div>
                    </div>
                    <div
                      className={`taskAction d-flex align-items-center ${singleTasks.task_status}`}
                    >
                      <p>
                        {singleTasks.task_status.charAt(0).toUpperCase() +
                          singleTasks.task_status.slice(1)}
                      </p>
                    </div>
                  </div>
                  <div className="myTaskforDayDetails">
                    <span>{singleTasks.task.description}</span>
                  </div>
                  <div className=" d-flex">
                    <div className="ml-auto">
                      <div
                        className="viewDetails"
                        onClick={() => onViewDeails(singleTasks?.user_task_id)}
                      >
                        View Details
                      </div>
                    </div>
                  </div>
                </li>
              ))
            )}
            {/* {todayTask?.user_tasks_map?.map((singleTask, index) => (
              <Card key={index} className="taskEditList_blk">
                <p>{singleTask?.task?.taskTypeByTaskType.type_name}</p>
                <div className=" d-flex justify-content-end">
                  <div className={`tagStatus ${`singleTask.task_type`}`}>
                    {`singleTask.taskTypeByTaskType.type_name`}
                  </div>
                </div>
                <div>{`singleTask.description`}</div>
              </Card>
            ))} */}
          </ul>
        </div>
      </div>
      
      {showQrDrawer && (
        <TaskQrCodeModal
          userPermission={permission.allow_qr_code}
          userTaskId={userTaskId}
          showQrDrawer={showQrDrawer}
          setShowQrDrawer={setShowQrDrawer}
        />
      )}
    </Fragment>
  );
};
